module.exports = __webpack_public_path__ + "img/spotangels.0ab138f8.svg";